// Sidebar Routers
// WORDT NIET MEER GERBUIKT -> ONLINE OPHALEN
export const menus = {
	'message.posworld': [
		{
			action: 'zmdi-view-dashboard',
			title: 'message.dashboard',
			active: true,
			items: null,
			path: '/dashboard'
		},
		{
			action: 'zmdi-accounts-alt',
			title: 'message.customers',
			active: false,
			items: null,
			path: '/customerlst'
		},
		{
			action: 'zmdi-email-open',
			title: 'message.basicdata',
			active: false,
			items: [
				{ title: 'message.services', path: '/articles/servicelst', exact: false },
				{ title: 'message.products', path: '/articles/productlst', exact: false },
				{ title: 'message.categoriesserv', path: '/articles/categoryservlst', exact: false },
				{ title: 'message.categoriesprod', path: '/articles/categoryprodlst', exact: false },
				{ title: 'message.suppliers', path: '/articles/supplierlst', exact: false }
			]
		},
		{
			action: 'zmdi-grid',
			title: 'message.reports',
			active: false,
			items: [
				{ title: 'message.monthreport', path: '/reports/monthreport', exact: false },
				{ title: 'message.salesreport', path: '/reports/salesreport', exact: false },
				{ title: 'message.monthservices', path: '/reports/monthservices', exact: false },
				{ title: 'message.monthproducts', path: '/reports/monthproducts', exact: false },
				{ title: 'message.monthusersreport', path: '/reports/monthuserreports', exact: false },
				{ title: 'message.appointments', path: '/reports/appointlistreport', exact: false },
			]
		},
		{
			action: 'zmdi-file',
			title: 'message.stock',
			active: false,
			items: [
				{ title: 'message.stock', path: '/reports/stockreport', exact: false },
				{ title: 'message.inventory', path: '/reports/inventoryreport', exact: false }
			]
		}
	],	
	'message.settings': [
		{
			action: 'zmdi-email-open',
			title: 'message.mailsettings',
			active: false,
			items: [
				{ title: 'message.settings', path: '/mail/mailconfig', exact: false },
				{ title: 'message.editor_newappoint', path: '/mail/appnew', exact: false },
				{ title: 'message.editor_appreminder', path: '/mail/appreminder', exact: false },
				{ title: 'message.editor_appdelete', path: '/mail/appdelete', exact: false },
				{ title: 'message.editor_appdelete', path: '/mail/onlineappbasket', exact: false },
				//{ title: 'message.editor_appnewcust', path: '/mail/appnewcust', exact: false },
				//{ title: 'message.editor_appgetpasswd', path: '/mail/appgetpassword', exact: false }
			]
		},
		{
			action: 'zmdi-comment-dots',
			title: 'message.smssettings',
			active: false,
			items: [
				{ title: 'message.settings', path: '/sms/smsconfig', exact: false },
				{ title: 'message.smshistorique', path: '/sms/smshistorique', exact: false }
			]
		},
		{
			action: 'zmdi-account',
			title: 'message.users',
			active: false,
			items: null,
			path: '/userlst'
		},
		{
			action: 'zmdi-globe',
			title: 'message.onlinereservation',
			active: false,
			items: [
				{ action: 'zmdi-globe', title: 'message.settings', path: '/onlinereservation/onlinereservationsettings', exact: false },
				{ action: 'zmdi-globe', title: 'message.categoryorder', path: '/onlinereservation/onlinecategoryorder', exact: false },
				{ action: 'zmdi-globe', title: 'message.onlinecontrol', path: '/onlinereservation/onlinecontrolsystem', exact: false },
			]
		},
		{
			action: 'zmdi-star',
			title: 'message.modules',
			active: false,
			items: [
				{ title: 'message.mailchimp', path: '/settings/mailchimp', exact: false },
			]
		}
	]
}
